if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.nextButton = this.querySelector('[js-next]');
        this.prevButton = this.querySelector('[js-prev]');

        this.nextButton.addEventListener('click', () => {
          const activeThumbnail = this.querySelector('.thumbnail[aria-current="true"]').parentElement;
          let activeThumbnailNext = this.getNextVisibleElement(activeThumbnail);

          this.setActiveMedia(activeThumbnailNext.dataset.target, false);
        });
        this.prevButton.addEventListener('click', () => {
          const activeThumbnail = this.querySelector('.thumbnail[aria-current="true"]').parentElement;
          let activeThumbnailNext = this.getPrevVisibleElement(activeThumbnail);

          this.setActiveMedia(activeThumbnailNext.dataset.target, false);
        });

        // For combined listings on mobile, update active media based on scroll position
        if (this.dataset.combinedListing === 'true') {
          const sliderList = this.elements.viewer.querySelector('ul');
          if (sliderList) {
            sliderList.addEventListener('scroll', debounce(this.updateActiveMediaOnScroll.bind(this), 100));
          }
        }
      }

      getNextVisibleElement(element) {
        let nextElement = element.nextElementSibling;

        // Find the next visible sibling element
        while (nextElement) {
          if (this.isVisible(nextElement)) return nextElement;
          nextElement = nextElement.nextElementSibling;
        }

        // Loop through all elements to find the first visible one
        return [...this.querySelectorAll('.thumbnail-list__item')].find(this.isVisible) || null;
      }

      getPrevVisibleElement(element) {
        let prevElement = element.previousElementSibling;

        // Find the previous visible sibling element
        while (prevElement) {
          if (this.isVisible(prevElement)) return prevElement;
          prevElement = prevElement.previousElementSibling;
        }

        // Loop through all elements to find the first visible one
        return [...this.querySelectorAll('.thumbnail-list__item')].reverse().find(this.isVisible) || null;
      }

      // Helper function to check if an element is visible
      isVisible(el) {
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.dataset.activeMediaId = event.detail.currentElement.dataset.mediaId;
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        // Update the active media ID for pagination dots
        this.dataset.activeMediaId = mediaId;

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        // window.setTimeout(() => {
        //   if (!this.mql.matches || this.elements.thumbnails) {
        //     activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        //   }
        //   const activeMediaRect = activeMedia.getBoundingClientRect();
        //   // Don't scroll if the image is already in view
        //   if (activeMediaRect.top > -0.5) return;
        //   const top = activeMediaRect.top + window.scrollY;
        //   window.scrollTo({ top: top, behavior: 'smooth' });
        // });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        this.scrollIfOutOfView(activeThumbnail, this.elements.thumbnails);
      }

      scrollIfOutOfView(element, container) {
        const elementRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Calculate the element's position relative to the container
        const isOutOfViewport =
          elementRect.top < containerRect.top || // Element is above the container
          elementRect.bottom > containerRect.bottom; // Element is below the container

        if (isOutOfViewport) {
          // Use scrollIntoView with smooth behavior to bring the element into view
          element.scrollIntoView({
            behavior: 'smooth', // Smooth scroll animation
            block: 'end', // Scrolls the element into the center of the container
            inline: 'nearest', // Keeps horizontal scrolling to a minimum
          });
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      updateActiveMediaOnScroll() {
        const sliderList = this.elements.viewer.querySelector('ul');
        if (!sliderList) return;

        // Get all visible media items (displayed based on CSS)
        const visibleMediaItems = Array.from(sliderList.querySelectorAll('li[data-media-id]')).filter(item => {
          const style = window.getComputedStyle(item);
          return style.display !== 'none';
        });

        if (visibleMediaItems.length === 0) return;

        // Find which media item is currently most visible in the viewport
        const scrollLeft = sliderList.scrollLeft;
        const viewportCenter = scrollLeft + (sliderList.clientWidth / 2);

        let closestItem = visibleMediaItems[0];
        let closestDistance = Math.abs((closestItem.offsetLeft + closestItem.clientWidth / 2) - viewportCenter);

        visibleMediaItems.forEach(item => {
          const itemCenter = item.offsetLeft + item.clientWidth / 2;
          const distance = Math.abs(itemCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        });

        // Update the active media ID to match the closest item
        const mediaId = closestItem.dataset.mediaId;
        if (this.dataset.activeMediaId !== mediaId) {
          this.dataset.activeMediaId = mediaId;
        }
      }
    }
  );
}
